import { getRequest, postRequest } from './http';
import Cookies from 'universal-cookie';
import { encryptedDataAES, generateRSAKey } from 'utils/Encryption';
import { env } from '../env';

const cookies = new Cookies();
const baseURL = env.REACT_APP_BASE_URL;

export const AuthService = {
  login: async function (data) {
    const url = `${baseURL}/login/getToken`;
    const res = await postRequest(url, data);
    if (!res.tokenResfresh || res.tokenResfresh === undefined || res.tokenResfresh === '') {
      return {};
    }
    let key = cookies.get('KEY');
    let token = encryptedDataAES(res.tokenResfresh, key);
    cookies.set('X-AUTH-TOKEN-ENC', token, { path: '/' });
    localStorage.setItem('USER-INFO', JSON.stringify(res.data));
    // cookies.set('KEY-ENC', data.randomKeyEnc, { path: '/' });

    return {
      token: token,
      key: cookies.get('KEY-ENC'),
      errorDescription: res.errorDescription,
      errorCode: res.errorCode,
    };
  },

  logout: async function () {
    cookies.remove('X-AUTH-TOKEN-ENC');
    cookies.remove('KEY-ENC');
    cookies.remove('KEY');
    return {};
  },
};
